<template lang="pug">
v-container(style="max-width:600px")
  .mt-4
    .text-center(v-if="isLoading")
      v-progress-circular.ma-auto.my-8(width="2" size="50" color="primary" indeterminate)
    template(v-else)
      .mb-8(v-for="(event, key) in events" :key="event.key")
        .d-flex.mb-n2
          .flex-grow-1
            .s1 {{ $t('trigger_when') }} {{ event.description }}
          div
            y-switch(v-model="event.enabled")
        .p2.primary400--text.mb-1 {{ $t('webhook_url') }}
        .d-flex.align-center
          v-text-field.mr-2(
            v-model="event.url"
            :disabled="!event.enabled"
            background-color="basic200"
            height="40"
            label="Webhook URL"
            solo
            flat
            placeholder="eg: https://www.zapier.com/abcd123"
            outlined 
            dense 
            persistent-hint
            hide-details)
          v-btn.button-Aa-medium.white--text.primary(depressed :disabled="!event.enabled" @click="testWebhook(key, event.url)") {{ $t('test') }}
      .text-right.mt-4
        v-btn.button-Aa-medium.white--text.px-4(
          @click="updateEvents"
          :loading="isUpdating"
          color="info500" 
          depressed
          height=40
        ) {{ $t('update') }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: {},
  data: () => ({
    isLoading: false,
    apiKey: '',
    events: {},
    isUpdating: false
  }),
  computed: {
    ...mapState('subscriptions', ['connectSubscription']),
    ...mapGetters({ company: 'getCompany' })
  },
  created() {
    this.fetchWebhooks()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchWebhooks() {
      this.isLoading = true
      this.$axios.get(`/webhooks/${this.company.slug}`)
      .then(response => {
        this.handleWebhookResponse(response.data)
      })
      .catch(() => {
        this.isLoading = true
        this.$axios.post('/webhooks/', { company: this.company.id })
        .then(response => {
          this.handleWebhookResponse(response.data)
        })
        .catch(() => {})
      })
    },
    handleWebhookResponse(data) {
      this.apiKey = data.api_key
      this.events = data.events
      for (const key in this.events) {
        if (!key.includes('Connect')) {
          delete this.events[key]
        }
      }
      this.isLoading = false
    },
    testWebhook(event, url) {
      const data = {
        api_key: this.apiKey,
        event: event,
        url: url
      }
      this.$axios.post(`/webhooks/${this.company.slug}/test`, data)
      .then(() => {
      }).catch(() => {})
    },
    updateEvents() {
      this.isUpdating = true
      this.$axios.patch(`/webhooks/${this.company.slug}`, { events: this.events })
      .then(() => {
        this.showMessage(['success', this.$t('success_message.webhook_integration_success')])
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isUpdating = false
      })
    },
  }
}
</script>

<style scoped>
</style>

<i18n>
  {
    "en": {
      "trigger_when": "Trigger when",
      "webhook_url": "Webhook URL"
    },
    "id": {
      "trigger_when": "Aktifkan ketika",
      "webhook_url": "Webhook URL"
    }
  }
  </i18n>
  